import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Match } from '../../../_shared/models/match.model';
import { StatsFilter } from '../../../_shared/models/statsFilters.model';
import { BoardHelpService } from '../../../match-tracker/tracker-board/board-help.service';

@Component({
  standalone: false,
    selector: 'app-stats-filter-updater',
    templateUrl: './stats-filter-updater.component.html',
    styleUrls: ['./stats-filter-updater.component.scss'],
})
export class StatsFilterUpdaterComponent implements OnInit {
    @Input() filters: StatsFilter;
    @Input() match: Match;

    form: UntypedFormGroup;
    constructor(
        private fb: UntypedFormBuilder,
        private modalController: ModalController,
        public boardHelpService: BoardHelpService
    ) { }

    ngOnInit() {
        this.buildForm();
    }

    buildForm() {
        this.form = this.fb.group({
            serverPlayerNumber: [''],
            rallyLength: [''],
            serveLocation: [''],
            returningSide: [''],
            pointsPlayer1: [''],
            pointsPlayer2: ['']
        });

        if (this.filters) this.form.setValue(this.filters);
    }

    dismiss() {
        this.modalController.dismiss(this.form.value);
    }

    getPlayers() {
        const players = [];
        this.match.sides.forEach((side, i) => {
            side.players.forEach((player, j) => {
                players.push({
                    name: `${player?.participant?.first_name} ${player?.participant?.last_name}`,
                    value: i * 2 + j + 1
                });
            });
        });
        return players;
    }

}
